module.exports = __webpack_public_path__ + "static/media/message-icon.76e55a97.svg";